import { withStyles } from '@material-ui/core/styles';

import EditForm from '../maintainer/edit';
import Form from './form';
import Service from '../../services/commune-service';
import { isRequired } from '../../libraries/validators';
import { reduceSpaces } from '../../libraries/utils';
import { editionMaintainer as styles } from '../maintainer/styles';

const Edit = props => {
  const service = Service;

  const getErrors = values => {
    const { region } = values;
    const errors = {};
    const minimumValues = {
      code: values.code,
      nameEFX: values.nameEFX,
      name: values.name,
      province: values.province,
      region: region && region.enabled ? region : ''
    };

    const newValues = Object.entries(minimumValues).reduce(reduceSpaces, {});
    isRequired(errors, newValues);
    return errors;
  };

  return {
    getErrors,
    service,
    keyName: 'id'
  };
};

export default withStyles(styles)(EditForm(Edit)(Form));
